import { PipelinePage } from "db"

import getPipelinePublicUrl, { PipelinePublicUrlProps } from "./getPipelinePublicUrl"

enum ScreenshotType {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

const getPageScreenshotUrl = (
  pipeline: PipelinePublicUrlProps,
  page: Pick<PipelinePage, "key">,
  screenshotType: ScreenshotType
) => {
  const publicUrl = getPipelinePublicUrl(pipeline).toString()
  const key = page.key || "index"

  return `${publicUrl}screenshot-${key}.${screenshotType}.png`
}

export default getPageScreenshotUrl
export { ScreenshotType }
